import React from 'react';
import { Lock, ShieldCheck, Menu } from 'lucide-react';
import ViewSwitcher from '../common/ViewSwitcher';
import SearchBar from '../common/SearchBar';

export default function TitleBar({
  activeView,
  onViewChange,
  searchQuery,
  onSearchChange,
  isAdmin,
  onOpenAdminModal,
  onToggleMobileSidebar
}) {
  return (
    <header className="min-h-18 sm:h-20 bg-[#240407] border-b border-[#4E0A10] px-2.5 sm:px-6 py-2 flex items-center justify-between shrink-0 z-30 shadow-md gap-2 sm:gap-4">
      {/* Left: Mobile hamburger menu toggle + Brand 'Lại AI' */}
      <div className="flex items-center space-x-2 sm:space-x-3 shrink-0">
        {/* Mobile Sidebar Hamburger Toggle */}
        <button
          onClick={onToggleMobileSidebar}
          className="md:hidden p-1.5 rounded-xl border border-[#6E141E] bg-[#34070B] text-amber-200/80 hover:text-[#FFF5E6] hover:bg-[#480C12] transition"
          title="Danh mục & Bộ lọc"
        >
          <Menu size={18} />
        </button>

        {/* Brand Mark: Lại AI */}
        <div className="flex items-center space-x-2 sm:space-x-2.5 cursor-pointer">
          <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-gradient-to-br from-[#B31B27] via-[#850E17] to-[#4A060C] border border-[#F5A623]/70 flex items-center justify-center shadow-md shrink-0">
            <span className="text-base select-none">🧧</span>
          </div>
          <div className="flex flex-col">
            <span className="text-base sm:text-xl font-black font-serif bg-gradient-to-r from-[#FFF0BA] via-[#F5A623] to-[#E58F10] bg-clip-text text-transparent tracking-tight leading-none">
              Lại AI
            </span>
            <span className="text-[9px] text-amber-200/60 font-semibold tracking-wider uppercase mt-0.5 hidden xs:inline">
              Deal Tết Siêu Hời
            </span>
          </div>
        </div>
      </div>

      {/* Center: Prominent Custom Search Bar with Dress & iPhone Badges */}
      <div className="flex-1 max-w-xl md:max-w-2xl flex justify-center min-w-0">
        <SearchBar value={searchQuery} onChange={onSearchChange} />
      </div>

      {/* Right: 3 macOS View Switchers & Discreet Admin Lock Button */}
      <div className="flex items-center space-x-2 shrink-0">
        <div className="hidden sm:block">
          <ViewSwitcher activeView={activeView} onViewChange={onViewChange} />
        </div>

        {/* Discreet Admin Trigger */}
        <button
          onClick={onOpenAdminModal}
          className={`p-2 rounded-xl border transition flex items-center gap-1.5 text-xs font-semibold ${
            isAdmin
              ? 'bg-gradient-to-r from-[#F5A623] to-[#E58F10] border-[#F5A623] text-[#240306] shadow-sm'
              : 'border-[#5A0D14] bg-[#30060A] text-amber-200/60 hover:text-amber-100 hover:border-[#8E1722] hover:bg-[#45090F]'
          }`}
          title={isAdmin ? 'Khu vực quản trị (Đang đăng nhập)' : 'Khu vực quản trị'}
        >
          {isAdmin ? (
            <>
              <ShieldCheck size={14} className="text-[#240306]" />
              <span className="hidden lg:inline uppercase tracking-wider text-[11px] font-extrabold">
                Quản trị
              </span>
            </>
          ) : (
            <Lock size={14} />
          )}
        </button>
      </div>
    </header>
  );
}
